import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { debounce } from "lodash";
import { resolveCountryName } from "../../constants/Country";
import { useNavigate } from "react-router-dom";
import {
  BlockHead,
  BlockTitle,
  BlockHeadContent,
  Icon,
  BlockBetween,
  Block,
} from "../../components/Component";
import StatCard, { StatCardGroup } from "../../components/partials/StatCard";
import { Badge } from "reactstrap";
import BasePaginationTable from "../../components/table/BasePaginationTable";
import { useSelector } from "react-redux";
import { defaultParams } from "../../constants";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  deleteCoachSuccess,
  getListCoach,
  updateCoachSuccess,
} from "../../slice/coaches";
import { approveUser, deleteUser } from "../../api/user";
import DeleteConfirmationModal from "../admin/modals/DeleteConfimationModal";
import { getDetailSuccess } from "../../slice/user-detail";
import TableActions from "../../components/table/TableActions";
import TableUser from "../../components/table/TableUser";
import TableTime from "../../components/table/TableTime";

function getDefaultColumns(
  onEditClick,
  onDeleteClick,
  onApproveClick,
  isApproveLoading,
) {
  return [
    {
      head: <span className="sub-text">{"User"}</span>,
      cell: (row) => (
        <TableUser
          avatar={row.avatar}
          name={row.displayName || row.fullName || row.businessName}
          subtitle={row.email}
        />
      ),
    },
    {
      head: <span className="sub-text">{"Based In"}</span>,
      cell: (row) => <span>{resolveCountryName(row.basedIn)}</span>,
    },
    {
      head: <span className="sub-text">{"Joined Date"}</span>,
      cell: (row) => <TableTime value={row?.createdAt} />,
    },
    {
      head: <span className="sub-text">{"Status"}</span>,
      cell: (row) => (
        <span>
          <Badge
            className="badge-sm badge-dot has-bg d-none d-sm-inline-flex"
            color={row.approved ? "success" : "danger"}
          >
            {row.approved ? "Approved" : "Unapproved"}
          </Badge>
        </span>
      ),
    },
    {
      head: <span className="sub-text"></span>,
      cellClassName: "nk-tb-col-tools",
      cell: (row) => (
        <TableActions
          actions={[
            {
              label: row.approved ? "Unapprove" : "Approve",
              icon: row.approved ? "user-cross" : "user-check",
              onClick: () => onApproveClick(row),
            },
            { label: "Edit", icon: "eye", onClick: () => onEditClick(row) },
            {
              label: "Delete",
              icon: "delete",
              danger: true,
              onClick: () => onDeleteClick(row),
            },
          ]}
        />
      ),
    },
  ];
}
const CoachesPage = () => {
  const navigate = useNavigate();
  const goToDetail = (user) => {
    dispatch(getDetailSuccess(user));
    navigate(`/coaches/${user._id}`);
  };

  const [params, setParams] = useState(defaultParams);
  const [isApproveLoading, setApproveLoading] = useState("-1");
  const dispatch = useDispatch();
  const { list, summary, serviceTypeStats, loading } = useSelector(
    (state) => state.coaches,
  );
  const [isCoachModalVisible, setCoachModalVisible] = useState({
    coach: null,
    delete: false,
  });
  const onDelete = (coach) => {
    setCoachModalVisible({ coach, delete: true });
  };
  const closeModal = () => {
    setCoachModalVisible({
      coach: null,
      delete: false,
    });
  };
  useEffect(() => {
    dispatch(getListCoach(params));
  }, [dispatch, params]);
  const handlePageChange = (page) => {
    setParams({
      ...params,
      page,
    });
  };
  /// func
  const onDeleteCoach = async () => {
    try {
      await deleteUser(isCoachModalVisible.coach?._id);
      dispatch(deleteCoachSuccess(isCoachModalVisible.coach));
      toast.success("Delete coach successfully");
    } catch (error) {
      toast.error(error);
    }
  };
  const approvedCoach = async (coach) => {
    setApproveLoading(coach?._id);
    try {
      const res = await approveUser(coach?._id, {
        approved: !coach?.approved,
      });
      toast.success("Update user successfully");
      dispatch(updateCoachSuccess(res));
    } catch (error) {
      toast.error(error);
    }
    setApproveLoading("-1");
  };

  const dataTableColumns = getDefaultColumns(
    goToDetail,
    onDelete,
    approvedCoach,
    isApproveLoading,
  );
  const [smOption, setSmOption] = useState(false);

  const _handleInputChange = (value) => {
    setParams((prev) => ({
      ...prev,
      keyword: value,
    }));
  };
  const handleInputChange = debounce(_handleInputChange, 500);
  return (
    <React.Fragment>
      <Head title="Coaches & Mentor"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Coaches & Mentor</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Search by name"
                          onChange={(e) => handleInputChange(e.target.value)}
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {serviceTypeStats && (
          <Block>
            <StatCardGroup>
              <StatCard
                title="Coaches & Mentor"
                total={serviceTypeStats.mentor?.total}
                approved={serviceTypeStats.mentor?.approved}
                unapproved={serviceTypeStats.mentor?.unapproved}
              />
            </StatCardGroup>
          </Block>
        )}
        <BasePaginationTable
          list={list}
          loading={loading}
          columns={dataTableColumns}
          onPageChange={handlePageChange}
          hasNextPage={summary?.hasNextPage}
          totalItems={summary?.count}
          onRowClick={goToDetail}
          {...params}
        />
      </Content>
      <DeleteConfirmationModal
        onConfirm={onDeleteCoach}
        isOpen={isCoachModalVisible.delete}
        onCloseModal={closeModal}
      />
    </React.Fragment>
  );
};

export default CoachesPage;
